import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3083fb20")

_pushScopeId("data-v-3083fb20")
const _hoisted_1 = {
  class: "aside-logo flex-column-auto",
  id: "kt_aside_logo"
}
const _hoisted_2 = { class: "aside-menu flex-column-fluid" }
const _hoisted_3 = { class: "mt-auto" }
const _hoisted_4 = { class: "menu-content flex-column-fluid aside-user-menu" }
const _hoisted_5 = { class: "symbol symbol-50px me-5" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_8 = {
  href: "javascript:void(0)",
  class: "fw-bold text-muted text-hover-primary fs-7"
}
const _hoisted_9 = { class: "layout-settings-area" }
const _hoisted_10 = { class: "menu-item-wrapper language-selector" }
const _hoisted_11 = {
  class: "menu-item",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "left-start",
  "data-kt-menu-flip": "center, top"
}
const _hoisted_12 = { class: "position-relative" }
const _hoisted_13 = { class: "selected-language d-flex flex-wrap align-items-center" }
const _hoisted_14 = { class: "symbol symbol-20px me-4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "fas fa-power-off fs-2 text-color-default" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AsideMenu = _resolveComponent("AsideMenu")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_InnerLoader, { loading: _ctx.loader }, null, 8, ["loading"]),
    _createVNode("div", {
      id: "kt_aside",
      class: ["aside aside-hoverable", [_ctx.asideTheme === 'light' && 'aside-light', _ctx.asideTheme === 'dark' && 'aside-dark', _ctx.asideOpened === true && 'aside-opened']],
      "data-kt-drawer": "false",
      "data-kt-drawer-name": "aside",
      "data-kt-drawer-activate": "{default: true, lg: false}",
      "data-kt-drawer-overlay": "true",
      "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
      "data-kt-drawer-direction": "start",
      "data-kt-drawer-toggle": "#kt_aside_mobile_toggle"
    }, [
      _createVNode("div", _hoisted_1, [
        (_ctx.asideTheme === 'dark')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/dashboard",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideOnClickOutsideHandler()))
            }, {
              default: _withId(() => [
                _createVNode("img", {
                  alt: "Logo",
                  src: _ctx.dynamicAsset,
                  class: "h-25 w-25 logo"
                }, null, 8, ["src"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.asideTheme === 'light')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: "/dashboard",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hideOnClickOutsideHandler()))
            }, {
              default: _withId(() => [
                _createVNode("img", {
                  alt: "Logo",
                  src: _ctx.dynamicAsset,
                  class: "h-25 w-25 logo"
                }, null, 8, ["src"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_AsideMenu, {
          hideCollapseableArea: _ctx.hideCollapseableArea,
          onValueChanged: _ctx.trueCollapseableArea
        }, null, 8, ["hideCollapseableArea", "onValueChanged"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", {
              class: "name-avatar",
              style: [{"color":"#ffffff"}, 'background:' + _ctx.companyLogo(_ctx.me?.name)?.color]
            }, _toDisplayString(_ctx.companyLogo(_ctx.me?.name)?.name), 5)
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, _toDisplayString(_ctx.me.name), 1),
            _createVNode("a", _hoisted_8, _toDisplayString(_ctx.me?.email), 1)
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: "",
                class: "menu-link btn-profile-default outside-click",
                onClick: _ctx.languageHandler
              }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_12, [
                    _createVNode("span", _hoisted_13, [
                      _createVNode("img", {
                        src: _ctx.currentLangugeLocale?.flag,
                        style: {"width":"290px"},
                        alt: "YellowBeard"
                      }, null, 8, ["src"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode("div", {
                class: ["menu-sub menu-sub-dropdown w-150px", { 'language-active': _ctx.languageArea }]
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.locales, (locale) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "menu-item",
                    key: locale.id
                  }, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.setLang(locale.locale, locale.id)),
                      href: "#",
                      class: ["menu-link d-flex", { active: _ctx.currentLanguage(locale?.locale) }]
                    }, [
                      _createVNode("span", _hoisted_14, [
                        _createVNode("img", {
                          class: "rounded-1",
                          src: locale?.flag,
                          alt: "YellowBeard"
                        }, null, 8, ["src"])
                      ]),
                      _createTextVNode(" " + _toDisplayString(locale.name), 1)
                    ], 10, ["onClick"])
                  ]))
                }), 128))
              ], 2)
            ])
          ]),
          _createVNode("a", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.signOut())),
            class: "aside-user-signout btn-profile-default d-flex align-items-center justify-content-center"
          }, [
            _hoisted_15
          ])
        ])
      ])
    ], 2)
  ], 64))
})